import { render, staticRenderFns } from "./phabout.vue?vue&type=template&id=7aff59fa"
import script from "./phabout.vue?vue&type=script&lang=js"
export * from "./phabout.vue?vue&type=script&lang=js"
import style0 from "./phabout.vue?vue&type=style&index=0&id=7aff59fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports